import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-location">
          <div>
            <span className="footer-kicker">VISITE NOSSA LOJA</span>
            <h2>Estamos em Goiânia, GO</h2>
            <p>Av. Anápolis - Loteamento Tupinambá dos Reis, Goiânia - GO, 74769-745</p>
          </div>
          <a className="footer-directions" href="https://www.google.com/maps/dir/?api=1&destination=MDA+seguranca+eletronica+e+energia+solar%2C+Goiania%2C+GO" target="_blank" rel="noopener noreferrer">
            Como chegar <span aria-hidden="true">↗</span>
          </a>
        </div>
        <iframe className="map-embed"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d568.2056036578092!2d-49.179819124814664!3d-16.65603156284579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935eeddf5ee4a7df%3A0x44954b20e27609c9!2sMUNDO%20DA%20AUTOMA%C3%87%C3%83O%20ENERGIA%20SOLAR%20-%20Sistema%20de%20seguran%C3%A7a!5e0!3m2!1spt-BR!2sbr!4v1758843473247!5m2!1spt-BR!2sbr"
          width="100%"
          height="360"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Mapa — Mundo da Automação Energia Solar (Goiânia)"
        />
        <div className="footer-content">
          <div className="footer-section about">
            <h3>Sobre Nós</h3>
            <p>Mundo da Automação é uma empresa Goiana que atua no mercado desde 2015 com inúmeros serviços de automação tecnológica para casas, condomínios e empresas.</p>
          </div>

          <div className="footer-section links">
            <h3>Links Rápidos</h3>
            <ul>
              <li><Link to="/">Início</Link></li>
              <li><Link to="/quem-somos">Quem Somos</Link></li>
              <li><Link to="/produtos">Produtos</Link></li>
            </ul>
          </div>
          
          <div className="footer-section contact">
            <h3>Contato</h3>
            <p><i className="fas fa-map-marker-alt"></i> Goiânia, GO</p>
            <a 
              href="https://api.whatsapp.com/send?phone=556232949182" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <p> <i className="fa-brands fa-whatsapp fa-lg" style={{ color: "#25D366", opacity: 1 }}></i> (62) 3294-9182</p>
              <a 
                href="tel:+556232949182" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <p> <i className="fas fa-phone" style={{ color: "#25D366", opacity: 1 }}></i> (62) 3294-9182</p>
              </a>
            </a>
            <p><i className="fas fa-envelope"></i> contato@mdaenergiasolar.com.br</p>            
              <i className="fas fa-map-marker-alt text-red-600"></i>
              <span>
                Av. Anápolis - Loteamento tupinambá dos Reis, Goiânia - GO, 74769-745
              </span>              
            <div className="social-links">
              <a href="https://www.instagram.com/mda_energiasolar/#" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/people/Mundo-da-Automa%C3%A7%C3%A3o/61569050150078/" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Mundo Automação Energia Solar. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
